import React from 'react';
import { CTAButton } from '../CTAButton';
const chain = ['OBJECTIVE', 'MOVEMENT', 'FORCES', 'REACTIONS', 'ANCHORAGE', 'ACTIVATION', 'CONTROL'];
export function TimeCost() {
  return <section className="bg-navy-900 py-14 sm:py-20" data-id="element-261" data-mp="4ezrfzl8gjym">
      <div className="mx-auto w-full max-w-3xl px-4" data-id="element-262" data-mp="4d530bar69ps">
        <h2 className="text-center font-display text-[27px] font-bold leading-tight text-white sm:text-4xl" data-id="element-263" data-mp="9d9n0bavdmkr">
          How much time do you spend figuring out a complex mechanic before you activate it?
        </h2>

        <p className="mx-auto mt-5 max-w-xl text-center text-[16px] leading-relaxed text-white/75 sm:text-lg" data-id="element-264" data-mp="3cvuhufkugbvt">
          When a case becomes complex, knowing orthodontic theory isn’t always enough. You need to connect
          the full chain — and you need to do it before you intervene.
        </p>

        <ul className="mt-8 grid grid-cols-2 gap-2 sm:grid-cols-4" data-id="element-265" data-mp="2p4xie2a8j71g">
          {chain.map((step, index) => <li key={step} className="flex items-center justify-center rounded-xl bg-white/[0.07] px-2 py-3 text-center text-[11.5px] font-extrabold uppercase tracking-[0.08em] text-sky-400 ring-1 ring-white/10 sm:text-xs" data-id="element-266" data-mp="2u2qpcxjd452s" data-mpi={index}>
              <span className="mr-1.5 text-white/35" data-id="element-267" data-mp="2frstmx7mdlw0">{index + 1}</span>
              {step}
            </li>)}
          <li className="col-span-2 flex items-center justify-center rounded-xl bg-sky-600 px-2 py-3 text-center text-[11.5px] font-extrabold uppercase tracking-[0.08em] text-white sm:col-span-1" data-id="element-268" data-mp="2at84bstwommc">
            Before you act
          </li>
        </ul>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-269" data-mp="1wtow7013hba1">
          <CTAButton label="I want a structured system" data-id="element-270" data-mp="1wui629vcogwe" />
        </div>
      </div>
    </section>;
}